import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massDestroySliders } from '../../api/apiSliders';
import toast from 'react-hot-toast';

export const useMassDestroySliders = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: massDestroySliders,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['sliders'] });
            toast.success(data.message || 'Sliders deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to delete sliders';
            toast.error(errorMessage);
        },
    });
};